export const ENTITLEMENT_LIST: string = "entitlementList";
export const LOADER_IDENTIFIER: string = "loader";

export interface IUserEntitlementsProps {
  entitlementList: any[];
  loader: boolean;
  goBack: () => void;
  userEntitlementsRequest: () => void;
}
